export default __webpack_public_path__ + "static/media/react-mini.b6138430.svg";